import { Button } from "@/components/ui/button";
import { Mail, Instagram, Copy, Check, X, Sparkles } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const CONTACT_EMAIL = "tech@ipnovaai.com";
const CONTACT_INSTA = "ipnova.ai";

export default function ContactPlanModal({ open, onClose, planName }) {
  const [copied, setCopied] = useState(false);
  if (!open) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(CONTACT_EMAIL); setCopied(true); setTimeout(() => setCopied(false), 1600); toast.success("Email copied"); }
    catch { toast.error("Copy failed"); }
  };
  const subject = encodeURIComponent(`Activate my ${planName || ""} plan`.trim());
  const body = encodeURIComponent(
    `Hi ipnova team,\n\nI'd like to activate my ${planName || "Pro"} plan. Please let me know the next steps.\n\nThanks!`
  );

  return (
    <div className="fixed inset-0 z-[70] bg-black/85 backdrop-blur-sm grid place-items-center p-4 overflow-y-auto" onClick={onClose} data-testid="contact-plan-modal">
      <div onClick={(e) => e.stopPropagation()} className="ai-border rounded-2xl bg-zinc-950 max-w-md w-full">
        <div className="rounded-2xl bg-black p-7">
          <div className="flex items-start justify-between mb-5">
            <div>
              <div className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-2.5 py-1 mb-3">
                <Sparkles className="w-3 h-3"/> Activate plan
              </div>
              <div className="font-display text-2xl tracking-tighter">Contact our team to go Pro</div>
              <div className="text-zinc-400 mt-1 text-sm">
                We're finalising our payments partner. Until then, reach out and we'll activate your account in minutes.
              </div>
            </div>
            <button onClick={onClose} className="text-zinc-500 hover:text-white shrink-0" data-testid="contact-close"><X className="w-5 h-5"/></button>
          </div>

          <div className="space-y-3">
            <a href={`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`} className="block" data-testid="contact-email-cta">
              <div className="flex items-center justify-between bg-zinc-950 border border-white/10 rounded-xl p-4 hover:border-emerald-500/30 transition">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 rounded-md bg-emerald-500/10 border border-emerald-500/30 grid place-items-center shrink-0">
                    <Mail className="w-4 h-4 text-emerald-400" />
                  </div>
                  <div className="min-w-0">
                    <div className="text-xs tracking-[0.2em] uppercase text-zinc-500">Email us</div>
                    <div className="text-sm font-medium truncate">{CONTACT_EMAIL}</div>
                  </div>
                </div>
                <button type="button" onClick={(e) => { e.preventDefault(); copy(); }} className="text-zinc-400 hover:text-white shrink-0">
                  {copied ? <Check className="w-4 h-4 text-emerald-400"/> : <Copy className="w-4 h-4"/>}
                </button>
              </div>
            </a>
            <a href={`https://instagram.com/${CONTACT_INSTA}`} target="_blank" rel="noreferrer" className="block" data-testid="contact-instagram-cta">
              <div className="flex items-center gap-3 bg-zinc-950 border border-white/10 rounded-xl p-4 hover:border-emerald-500/30 transition">
                <div className="w-9 h-9 rounded-md bg-emerald-500/10 border border-emerald-500/30 grid place-items-center shrink-0">
                  <Instagram className="w-4 h-4 text-emerald-400" />
                </div>
                <div>
                  <div className="text-xs tracking-[0.2em] uppercase text-zinc-500">DM on Instagram</div>
                  <div className="text-sm font-medium">@{CONTACT_INSTA}</div>
                </div>
              </div>
            </a>
          </div>

          <div className="mt-5 text-xs text-zinc-500 text-center">We usually respond within a few hours.</div>

          <Button onClick={onClose} variant="outline" className="mt-5 w-full bg-transparent border-white/10 text-zinc-300 hover:bg-white/10 h-10" data-testid="contact-dismiss">
            Maybe later
          </Button>
        </div>
      </div>
    </div>
  );
}
